import * as React from "react";
import * as styles from "./styles";
import { Link } from "react-router-dom";
import Loading from "components/Loading";
import { classes } from "typestyle";

interface IProps {
  variant?: "lightblue" | "darkblue" | "green" | "outlined" | "blueOutline" | "white";
  size?: "small" | "large";
  onClick: (e: React.FormEvent) => void;
  type?: "button" | "submit";
  children?: React.ReactNode;
  loading?: boolean;
  hidden?: boolean;
  style?: any;
}

const Button: React.FC<IProps> = ({
  variant,
  size = "large",
  onClick,
  type,
  children,
  loading,
  hidden,
  style,
}) => (
  <button
    className={classes(styles.button, styles[variant], styles[size])}
    onClick={onClick}
    type={type}
    style={{ visibility: hidden ? "hidden" : "visible", ...style }}
  >
    {children}
    {loading && (
      <div className={styles.loadingWrapper}>
        <Loading size="small" color="white" />
      </div>
    )}
  </button>
);

Button.defaultProps = {
  variant: "darkblue",
  type: "button",
  loading: false,
  hidden: false,
};

interface ILinkButtonProps {
  variant?: "lightblue" | "darkblue" | "green" | "outlined" | "blueOutline";
  size?: "small" | "large";
  to: string;
  children?: React.ReactNode;
  hidden?: boolean;
}

export const LinkButton: React.FC<ILinkButtonProps> = ({
  variant,
  size = "large",
  to,
  children,
  hidden,
}) => (
  <Link
    to={to}
    className={classes(styles.button, styles.linkButton, styles[variant], styles[size])}
    style={{ visibility: hidden ? "hidden" : "visible" }}
  >
    {children}
  </Link>
);

export const OutsideLinkButton: React.FC<ILinkButtonProps> = ({
  variant,
  size = "large",
  to,
  children,
  hidden,
}) => (
  <a
    href={to}
    className={classes(styles.button, styles.linkButton, styles[variant], styles[size])}
    style={{ visibility: hidden ? "hidden" : "visible" }}
  >
    {children}
  </a>
);

export default Button;
